<div class="qatch-home-container">
  <section class="home-section" #userRegisterForm>
    <app-first-block (events)="switchPage($event)" [isMobile]="isMobile">
    </app-first-block>
  </section>
  <section class="vpy-6 d-flex">
    <div class="m-auto text-center vmy-3 second-section w-90">
      <div data-aos="zoom-in" class="home-description vmb-3 lh-lg">What is Qatch?</div>
      <div data-aos="zoom-in" class="home-heading">Interactive Style Content via Text To Help Gen-Z &
        Millennial Women Discover More of What They Love
      </div>
      <div data-aos="zoom-in" class="home-description vmt-3 vmb-6 lh-lg">Join the 100,000+ women who trust Qatch - it's
        Free!
      </div>

      <div class="text-center vmt-6 mx-auto" style="max-width: 40em;">
        <q-button title="Get Started" (click)="onSignup();"></q-button>
      </div>
    </div>
  </section>
  <section class="vpy-6 d-flex flex-column justify-content-center align-items-center" style="background: #fcf7f6;">
    <div class="third-section d-flex flex-column justify-content-center align-items-center vmy-3">
      <div class="mx-auto">
        <div data-aos="zoom-in" class="home-heading text-center">Take our Style Quiz to Get Matched with Products You’ll Love</div>
        <p class="title home-description text-muted vmt-2 vmb-4"> First, pick the categories you’d like personal product recommendations from:</p>
      </div>
      <div class="vw-100 convo-cards-area">
        <q-convo [loading]="convoCardsLoading" [convoCards]="convoCards" type="CAROUSEL"
          (onUpdate)="onSignup();"></q-convo>
      </div>
      <div class="text-center vmt-6 mx-auto" style="max-width: 40em;">
        <q-button title="GET STARTED" (click)="onSignup();"></q-button>
      </div>
    </div>
  </section>
  <section class="wave-image-area">
    <div class="vpy-6">
      <div class="container-fluid d-none d-md-block">
        <uikit-wave></uikit-wave>
      </div>
      <div class="d-flex">
        <div class="mx-auto w-100 position-relative">
          <div data-aos="zoom-in" class="home-heading text-center position-relative vmt-3 vmb-6">
            Shop Popular Recs
            <div data-aos="zoom-in" class="position-absolute shop-popular Caveat-Bold d-block" [class.mobile-view]="isMobile">
              every product you love via text is saved to your account <a class="Caveat-Bold" href="/signin">here</a> !
              <img src="./assets/img/home/fifth-block/dislike-arrow.png" class="dislike-arrow float-end">
            </div>
          </div>
          <div class="row g-2 q-card-list container px-3 m-auto popular-products">
            <div class="col row g-2"  *ngFor="let products of columns;" style="height: fit-content">
              <uikit-product *ngFor="let product of products;" [productMeta]="productMeta" 
                [data]="product" [showReactionButton]="false"
                [maxShowIndex]="3" [lovedCount]="productMapping[product.product_id]"
                (onClick)="onProductClick($event)">
              </uikit-product>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="how-it-work vpy-6">
    <div class="d-flex flex-column justify-content-center align-items-center container p-0 g-0">
      <div data-aos="zoom-in" class="home-heading vmt-3 vmb-6 text-center">How Qatch Works</div>
      <div class="d-md-flex flex-md-row justify-content-between">
        <div class="col vp-2 text-center">
          <div class="img-container" style="background: url('../../../../assets/img/home/1.png');">
          </div>
          <div class="w-90 mx-auto">
            <h5 class="fw-bold my-1 Obviously-Wide">1.</h5>
            <h5 class="fw-bold mb-4">Take Our Style Quiz To Get Started</h5>
            <p>Our 3 minute quiz helps us identify which styles to start sending you</p>
          </div>
        </div>
        <div class="col vp-2 text-center">
          <div class="img-container" style="background: url('../../../../assets/img/home/2.gif');">
          </div>
          <div class="w-90 mx-auto">
            <h5 class="fw-bold my-1 Obviously-Wide">2.</h5>
            <h5 class="fw-bold mb-4">Rate Your Weekly Recommendations</h5>
            <p>Add us to your contacts & rating each product with a Love or Dislike so we can learn your style over time</p>
          </div>
        </div>
        <div class="col vp-2 text-center">
          <div class="img-container" style="background: url('../../../../assets/img/home/3.gif');">
          </div>
          <div class="w-90 mx-auto">
            <h5 class="fw-bold my-1 Obviously-Wide">3.</h5>
            <h5 class="fw-bold mb-4">Text Us Photos & We’ll Find Similar Items</h5>
            <p>Text REQUEST to start an outfit request; send a photo & we’ll help find similar items in your price point</p>
          </div>
        </div>
        <div class="col vp-2 text-center">
          <div class="img-container" style="background: url('../../../../assets/img/home/4.gif');">
          </div>
          <div class="w-90 mx-auto">
            <h5 class="fw-bold my-1 Obviously-Wide">4.</h5>
            <h5 class="fw-bold mb-4">Revisit Your Favorites In One Place</h5>
            <p>On mobile or desktop, sign into <strong class="cursor-pointer" routerLink="signin">joinqatch.com </strong> 
              to view all of your recs and browse 100's more weekly</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="vpy-6">
    <div class="eighth-block position-relative d-flex justify-content-center">
      <div class="text-center">
        <div class="Obviously-Wide vmy-3 vmx-5 home-heading" data-aos="zoom-in" style="max-width: 27em !important;">
          Whatever your budget, we'll help you discover your best style with recommendations from
        </div>
        <div class="home-description vmt-3 vmb-3" data-aos="zoom-in">
          brands you already know and love, plus 100's you'll love to discover
        </div>
        <div class="w-100">
          <div class="mx-auto mb-3 brand-carousal" style="max-width: 80em;">
            <app-brand-carousal [brands]="brandsLogoList1"></app-brand-carousal>
            <app-brand-carousal [brands]="brandsLogoList2" [antiClockwise]="true"></app-brand-carousal>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section style="background: #fdf7f6;">
    <wave-video-block></wave-video-block>
  </section>
  <section class="vpb-6" style="background: #fdf7f6;">
    <div class="d-flex flex-column justify-content-center align-items-center container vmb-3 circle-video-area">
      <ng-container *ngTemplateOutlet="sectionsHeader;context:circleVideoBlock.header"></ng-container>
      <div class="d-flex w-100 h-100 position-relative vmt-3">
        <video id="localVideoStream" class="video-circle"
          src="https://firebasestorage.googleapis.com/v0/b/qatchcode-production.appspot.com/o/videos%2Fhome_rate_recommendations.MOV?alt=media"
          autoplay [muted]="'muted'" loop></video>
        <div *ngIf="!isMobile" class="position-absolute d-flex align-items-center hint-1">
          <div class="d-flex align-items-center col-5 p-0 text-center">
            <p class="m-0 home-description text-bold">Click "Tap to Load Preview" to see your recommendation</p>
          </div>
          <div class="d-flex align-items-center col-7 p-0">
            <div class="line"></div>
            <div class="dot"></div>
          </div>
        </div>
        <div class="position-absolute {{!isMobile? 'd-flex justify-content-end align-items-center': ''}} hint-2">
          <div
            class="d-flex {{!isMobile? 'justify-content-end' : 'flex-column justify-content-center'}} align-items-center col-7 p-0"
            [class.m-auto]="isMobile">
            <div class="dot"></div>
            <div class="line"></div>
          </div>
          <div class="{{!isMobile? 'col-4 d-flex align-items-center p-0' : 'col-9 mx-auto'}} text-center">
            <p class="m-0 home-description text-bold">
              Double Tap the product or hold your finger over the item untill the Icon bubbles appear
            </p>
          </div>
        </div>
        <div class="position-absolute {{!isMobile? 'd-flex justify-content-center align-items-center': ''}} hint-3">
          <div class="{{!isMobile? 'col-5 d-flex align-items-center p-0' : 'col-9 mx-auto'}} text-center">
            <p class="m-0 home-description text-bold">
              Rate each product! This helps our algorithm learn your style and improve
            </p>
          </div>
          <div class="d-flex align-items-center col-7 p-0 {{!isMobile? '':'flex-column'}}" [class.mx-auto]="isMobile">
            <div class="line"></div>
            <div class="dot"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="vpy-6" style="background: #f4effe;">
    <div class="container-fluid p-0 gx-0 vmy-3">
      <div class=" d-none d-md-block text-center vmb-3">
        <h1 style="font-size: 3.9em" class="preFlex flexIn">
          <svg class="Marquee-svg" fill="currentColor" aria-hidden="true"
            style="height: 240px;width: 100%;margin-bottom: -130px;">
            <g class="Marquee-path-group">
              <path class="Marquee-path" fill="none" stroke="transparent" stroke-width="0"
                d="M-550,59.580000000000005  L-550,59.580000000000005 S-183.15,209.58 0,209.58 S366.85,59.580000000000005 550,59.580000000000005 S916.85,209.58 1100,209.58 S1466.85,59.580000000000005 1650,59.580000000000005 S2016.85,209.58 2200,209.58"
                stroke-dasharray="592 32.138 " id="545dd62a0597d2b81760" stroke-dashoffset="29"></path>
            </g>
            <text>
              <textPath class="Marquee-svg-text" href="#545dd62a0597d2b81760" startOffset="-29">
                <tspan class="Marquee-svg-text" *ngFor="let text of svgWaveText;">
                  New Collections Weekly &nbsp;</tspan>
                <animate attributeName="startOffset" from="0%" to="-100%" dur="120s" repeatCount="indefinite" />
              </textPath>
            </text>
            <g class="Marquee-hitbox">
              <g class="Marquee-path-hitbox-group">
                <path class="Marquee-path-hitbox" fill="none" stroke="transparent"
                  d="M-550,59.580000000000005  L-550,59.580000000000005 S-183.15,209.58 0,209.58 S366.85,59.580000000000005 550,59.580000000000005 S916.85,209.58 1100,209.58 S1466.85,59.580000000000005 1650,59.580000000000005 S2016.85,209.58 2200,209.58"
                  id="545dd62a0597d2b81760" stroke-width="90"></path>
                <path class="Marquee-path-hitbox-focus-outline" fill="none" stroke="transparent" stroke-width="2px" d="
                    M-550,240
                     L-550,81 S-183.15,231 0,231 S366.85,81 550,81 S916.85,231 1100,231 S1466.85,81 1650,81 S2016.85,231 2200,231
                    M-550,150
                     L-550,9 S-183.15,159 0,159 S366.85,9 550,9 S916.85,159 1100,159 S1466.85,9 1650,9 S2016.85,159 2200,159">
                </path>
              </g>
            </g>
          </svg>
        </h1>
      </div>
      <div class="px-3">
        <p-carousel #carouselRef [value]="specialists" [numVisible]="!isMobile ? 6 : 2" [numScroll]="1"
          [showIndicators]="false" [showNavigators]="true" [class.mobile-view]="!isMobile">
          <ng-template let-specialist pTemplate="item">
            <div class="owner text-center {{ !isMobile ? 'py-4' : 'py-1'}}">
              <div
                class="avatar p-0 m-0 collections{{isLoggedIn ? '_login' : ''}}_{{specialist.type === 'STYLIST' ? 'stylist' : 'ambassador'}}_click"
                (click)="goToProfile(specialist)">
                <img alt="{{ specialist.shop_title }}" [src]="specialist.logo"
                  class="img-circle img-responsive collections{{isLoggedIn ? '_login' : ''}}_{{specialist.type === 'STYLIST' ? 'stylist' : 'ambassador'}}_click">
              </div>
              <div
                class="card-body title-align mt-2 collections{{isLoggedIn ? '_login' : ''}}_{{specialist.type === 'STYLIST' ? 'stylist' : 'ambassador'}}_name_click"
                (click)="goToProfile(specialist)">
                <span class="card-title fs-14"> <u>{{ specialist.shop_title || specialist.name}}</u> </span>
                <!-- <p class="text-muted fs-12" *ngIf="specialist.collection_text"> {{ specialist.collection_text}} </p> -->
              </div>
              <div class="d-flex social justify-content-center mt-n3"
                *ngIf="!isMobile && (specialist.pinterest_url || specialist.instagram_url)">
                <a class="collections{{isLoggedIn ? '_login' : ''}}_pinterest_click"
                  href="{{ specialist.pinterest_url }}" target="_blank" *ngIf="specialist.pinterest_url"><img
                    src="./assets/img/social/pinterest.png" /></a>
                <a class="collections{{isLoggedIn ? '_login' : ''}}_instagram_click"
                  href="{{ specialist.instagram_url }}" target="_blank" *ngIf="specialist.instagram_url"><img
                    src="./assets/img/social/instagram.png" class="p-2" /></a>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>
    </div>
  </section>
  <section>
    <app-influences-interaction></app-influences-interaction>
  </section>
  <section class="vpy-6 vpx-4 my-5 slider-section">
    <div class="m-auto">
      <ng-container *ngFor="let items of sliderItems; index as indx;">
        <div class="home-heading" data-aos="fade-up" [innerHTML]="items.description"
          *ngIf="indx === (activeSlideItem - 1)"></div>
      </ng-container>
    </div>
  </section>
  <section>
    <app-request-feature [isMobile]="isMobile" [bgcolor]="'#f4effe'"></app-request-feature>
  </section>
  <section class="home-section d-flex justify-content-end align-items-xl-center bg-mobile vpy-6">
    <div class="text-end text-white">
      <div class="w-75 float-end vm-5">
        <div data-aos="zoom-in" class="home-heading vmb-6 me-0">Don't Be The Last To Know</div>
        <div data-aos="zoom-in" class="home-description w-60 me-0">Join over <span style="color: #eb602f">100K
            women</span> who use Qatch to save their time and look them best</div>
        <div class="vmt-6 d-flex justify-content-end">
          <q-button title="SIGN UP NOW" type="arrowButton" (click)="onSignup();"></q-button>
        </div>
      </div>
    </div>
  </section>
  <section class="moving-banner-section vpy-1 d-flex" [class.d-none]="isiPhone">
    <div class="animation-infinite-alternate vpx-5">
      <img src="./../../../../assets/img/home/tenth/3.png" height="44px" class="wwd" /> "Rocky Barnes Becomes
      Investor in Shopping Platform Qatch"
      <img src="./../../../../assets/img/home/tenth/4.png" height="45px" class="glossy" /> "How Qatch is gaming
      personalization"
      <img src="./../../../../assets/img/home/tenth/5.png" height="44px" class="gotham" /> "Women across the world
      are taking notice"
      <img src="./../../../../assets/img/home/tenth/6.png" height="45px" class="medium" /> "Bringing
      personalization to online shoppers"
    </div>
  </section>
  <section class="section sms-section vpy-6">
    <ng-container *ngTemplateOutlet="sectionsHeader;context:smsBlock.header"></ng-container>
    <div class="vmt-1">
      <lib-sms-gallery [smsList]="smsBlock.smsList"></lib-sms-gallery>
      <lib-sms-gallery [smsList]="smsBlock.smsList" [antiClockwise]="true"></lib-sms-gallery>
    </div>
  </section>
  <section class="get-social-section position-relative vpy-6" *ngIf="medias">
    <ng-container *ngTemplateOutlet="sectionsHeader;context:getSocialBlock.header"></ng-container>
    <div class="qatch-social-profiles vmy-1">
      <div class="row mx-auto justify-content-between vpy-2">
        <div class="col qatch-social-profile" *ngFor="let media of medias; index as indx;">
          <div class="d-flex vmy-2 home_lets_get_social_image_{{indx}}" data-aos="fade-up-left">
            <img class="tiktok-cover-image home_lets_get_social_image_{{indx}}" [src]="media.cover_image_url"
              (click)="openTiktokVideo(media);" [title]="media.title">
            <div class="tiktok-media top-50 start-50 translate-middle" (click)="openTiktokVideo(media);">
              <span class="play-icon"></span>
              <img src="./../../../../assets/img/social/tiktok.svg" class="tiktok-thumb">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<ng-template #sectionsHeader let-header="title" let-subHeader="subTitle">
  <div class="text-center" data-aos="zoom-in">
    <div class="home-heading vmt-3" [innerText]="header"></div>
    <div class="home-description vpy-3" [innerText]="subHeader"></div>
  </div>
</ng-template>